import { render } from "./ImportanceStatBar.vue?vue&type=template&id=c159cb76&scoped=true"
import script from "./ImportanceStatBar.vue?vue&type=script&lang=js"
export * from "./ImportanceStatBar.vue?vue&type=script&lang=js"

import "./ImportanceStatBar.vue?vue&type=style&index=0&id=c159cb76&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c159cb76"]])

export default __exports__